enum CaseTypes {
    GET_CASE = 'case/GET_CASE',
    GET_CASE_SUCCESS = 'case/GET_CASE_SUCCESS',
    GET_CASE_FAILURE = 'case/GET_CASE_FAILURE',
    UPDATING_CASE = 'case/UPDATING_CASE',
    UPDATE_CASE_SUCCESS = 'case/UPDATE_CASE_SUCCESS',
    UPDATE_CASE_FAILURE = 'case/UPDATE_CASE_FAILURE',
    CREATE_MESSAGE = 'case/CREATE_MESSAGE',
    CREATE_MESSAGE_SUCCESS = 'case/CREATE_MESSAGE_SUCCESS',
    CREATE_MESSAGE_FAILURE = 'case/CREATE_MESSAGE_FAILURE',
    SEARCH_CASES = 'case/SEARCH_CASES',
    SEARCH_CASES_RESET = 'case/SEARCH_CASES_RESET',
    SEARCH_CASES_SUCCESS = 'case/SEARCH_CASES_SUCCESS',
    SEARCH_CASES_FAILURE = 'case/SEARCH_CASES_FAILURE',
    UPLOAD_ATTACHMENT_ASK = 'case/UPLOAD_ATTACHMENT_ASK',
    UPLOAD_ATTACHMENT_REMOVE = 'case/UPLOAD_ATTACHMENT_REMOVE',
    UPLOAD_ATTACHMENT_ADD = 'case/UPLOAD_ATTACHMENT_ADD',
    UPLOAD_ATTACHMENT_SUCCESS = "case/UPLOAD_ATTACHMENT_SUCCESS",
    START_NEW_CASE = 'case/START_NEW_CASE',
    CREATE_NEW_CASE = 'case/CREATE_NEW_CASE',
    CREATE_NEW_CASE_SUCCESS = 'case/CREATE_NEW_CASE_SUCCESS',
    UPDATE_NEW_CASE = 'case/UPDATE_NEW_CASE',
    EXIT_NEW_CASE = 'case/EXIT_NEW_CASE',
    EXIT_CASE = 'case/EXIT_CASE',
    GET_FASCIAS_SUCCESS = 'case/GET_FASCIAS_SUCCESS',
    GET_CONTACT_BY_CASE_ID = 'case/GET_CONTACT_BY_CASE_ID',
    GET_CONTACT_BY_CASE_ID_SUCCESS = 'case/GET_CONTACT_BY_CASE_ID_SUCCESS',
    GET_CONTACT_BY_CASE_ID_FAILURE = 'case/GET_CONTACT_BY_CASE_ID_FAILURE',
    CLEAR = 'case/CLEAR',
}

export default CaseTypes;

export interface Case {
    ID: string;
    attributes?: Record<any, any>;
    messages?: Message[];
    status?: string;
    title: string;
    created: number;
    updated: number;
    from?: Address;
    fromName: string;
    fromAddress: string;
    to?: Address;
    cc?: Address;
    fascia?:Fascia;
}

export interface Message {
    ID: string;
    title?: string;
    created: number;
    updated: number;
    createdBy: string;
    createdByName?: string;
    content: string;
    attachments?: DownloadableAttachment[];
    type: string;
    externalID: string;
}

interface Attachment {
    filename: string;
    contentType: string;
    size: number;
}

export type DownloadableAttachment = Attachment & { downloadUrl: string }
export type UploadAttachment =
    | Attachment & { uploading: boolean, s3Key?: string }
    | undefined;

export interface Address {
    name?: string;
    address: string;
}

export interface Fascia {
    name: string;
    businessEmail: string;
}
